import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const IdleWarningModal = () => {
  const { showIdleWarning, resetIdleTimer } = useAuth();
  const [countdown, setCountdown] = useState(60); // 1 minute countdown

  useEffect(() => {
    let interval;
    
    if (showIdleWarning) {
      // Start countdown from 60 seconds
      setCountdown(60);
      
      interval = setInterval(() => {
        setCountdown(prevCountdown => {
          if (prevCountdown <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [showIdleWarning]);

  const handleStayLoggedIn = () => {
    resetIdleTimer();
  };

  if (!showIdleWarning) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-xl">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Session Timeout Warning</h2>
        <p className="text-gray-600 mb-6">
          You will be logged out due to inactivity in {countdown} seconds. Would you like to stay logged in?
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={handleStayLoggedIn}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
};

export default IdleWarningModal;
